import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { NgClass } from '@angular/common';

export interface ConfirmDialogSharedData {
  title: string;
  message: string;
  icon?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  confirmSeverity?: string | any;
}

@Component({
  selector: 'app-confirm-dialog-shared',
  imports: [ButtonModule, TranslatePipe, NgClass],
  templateUrl: './confirm-dialog-shared.component.html',
  styleUrl: './confirm-dialog-shared.component.scss'
})
export class ConfirmDialogSharedComponent {
  private readonly ref = inject(DynamicDialogRef);
  private readonly config = inject(DynamicDialogConfig);

  public data: ConfirmDialogSharedData = this.config.data;

  confirm() {
    this.ref.close(true);
  }

  cancel() {
    this.ref.close(false);
  }
}

